import classNames from 'classnames';
import { LinkFactoryOnClick } from 'common/link/link-on-click.js';
import { getPillPointerTranslate } from 'common/pill-v2/pill-pointer.js';
import { onClickStaticMapType } from 'components/map/map-controller/main/leaflet-click/click-updateSlot.js';
import { MarkerDisplaySize } from 'types/location.js';
import { MarkerTypeName } from 'types/markerTypesV2/m-v2-core.js';
import { IMarkerV2 } from 'types/markerTypesV2/m-v2-general.js';
import { convertToFlexAxisX, convertToFlexAxisY } from './pill-positioning.js';

export interface IPillMarkerCustomCoreV2 {
  staticPosition: IMarkerV2['position']['staticPoint'];
  offset: IMarkerV2['position']['offset'];
  labelPos: IMarkerV2['position']['labelPos'];
  displaySize: MarkerDisplaySize;
  selected?: boolean;
  /** used for storybook testing */
  mockHover?: boolean;
  markerType?: MarkerTypeName;
  hasPoint?: boolean;
  onClick?: onClickStaticMapType;
}

/** Displays Pill with label that can show/hide based on displayLabel */
export const PillDynamicWrapperV2 = ({
  staticPosition,
  labelPos: _labelPos,
  displaySize,
  onClick,
  selected,
  children,
  mockHover,
  markerType,
  hasPoint,
  offset,
  isDot,
  /** We remove the link here as this is now managed by the marker on click event */
}: Omit<IPillMarkerCustomCoreV2, 'link'> & { children: JSX.Element; isDot: boolean }): JSX.Element => {
  /** Do not display dots for label markers until required, designed and implemented */
  const labelPos = isDot ? 'centre' : _labelPos;

  const style =
    staticPosition ??
    getPillPointerTranslate({
      isDot,
      hasPoint,
      labelPos,
      pointOffsetX: offset?.x,
      pointOffsetY: offset?.y,
    });

  return (
    <div
      data-comp="pill-wrapper-c"
      className={staticPosition ? 'u-posAbs' : 'u-posRel'}
      data-marker={markerType ?? 'default'}
      style={style}
      data-pos={labelPos ?? 'default-right'}
    >
      <LinkFactoryOnClick
        className={`u-flex ${convertToFlexAxisX(labelPos)} ${convertToFlexAxisY(labelPos)}`}
        onClick={onClick}
      >
        <div
          data-comp="wrap-pill-content"
          className={classNames('u-flex u-isClickable border-radius-md u-posAbs pill-v2--hover-listen', {
            'pill--icon-no-shadow': displaySize === MarkerDisplaySize.Large,
            'pill--icon-shadow': selected || mockHover,
          })}
        >
          {children}
        </div>
      </LinkFactoryOnClick>
    </div>
  );
};
